import styled from '~/app/components/styled'
import { Typography } from '@yanolja-rnd/ya-com-core'

export const ItemContainer = styled.div`
  display: flex;
  width: 100%;
  ${Typography('body2').regular};
  position: relative;
  .check-icon-wrapper {
    flex: 0 0 2rem;
    align-items: flex-start;
    > img {
      height: 2rem;
      margin-right: 0.4rem;
    }
  }
  .image-wrapper {
    flex: 0 0 7.2rem;
    margin-left: 0.4rem;
    position: relative;
    &.fix-height {
      height: 7.2rem;
    }
    img {
      border-radius: 0.4rem;
      width: 100%;
      height: 100%;
    }
  }
  .icon-wrapper {
    cursor: pointer;
    position: absolute;
    width: 1.6rem;
    height: 1.6rem;
    top: 0;
    right: 0;
    svg {
      path {
        fill: ${({ theme }) => theme.color.gray600};
      }
    }
  }
`

export const DescContainer = styled.div`
  margin-left: 0.8rem;
  flex: 1 1 auto;
  position: relative;
  .bar {
    margin: 0 0.6rem;
    color: ${({ theme }) => theme.color.gray200};
  }
  div.row {
    display: flex;

    .cancel {
      margin-right: 0.8rem;
      display: flex;
      flex-direction: column;
      flex: 0 0 8rem;
    }

    .image {
      padding: 0.2rem 0 0 0.4rem;
      flex: 0 0 8rem;
      position: relative;
      &.fix-height {
        height: 7.2rem;
      }
      img {
        border-radius: 0.4rem;
        width: 100%;
        height: 100%;
      }
    }
    > div {
      flex: 1 1 auto;
    }
  }
`

export const OptionNameContainer = styled.div<{
  disabled: boolean
  cursorPointerDisabled?: boolean
}>`
  margin-bottom: 1.2rem;
  color: ${({ disabled, theme }) => (disabled ? theme.color.gray400 : theme.color.gray900)};
  cursor: ${({ cursorPointerDisabled }) => (cursorPointerDisabled ? 'default' : 'pointer')};
  ${Typography('subtitle3').bold};
`

export const OptionDescriptionContainer = styled.div<{
  disabled: boolean
}>`
  width: calc(100% - 1.5rem);
  color: ${({ disabled, theme }) => (disabled ? theme.color.gray400 : theme.color.gray900)};
  ${Typography('body1').regular};
`

export const BadgeContainer = styled.div`
  margin-top: 0.8rem;
  display: flex;
  align-items: flex-end;
  .badge-wrapper {
    &:nth-of-type(2) {
      margin-left: 0.4rem;
    }
  }
`

export const PriceContainer = styled.div<{ disabled?: boolean }>`
  flex: 0 0 100%;
  display: flex;
  justify-content: space-between;
  align-items: baseline;
  margin-top: 1.6rem;
  .price-wrapper {
    flex: 1 1 auto;
    color: ${({ disabled, theme }) => (disabled ? theme.color.gray400 : theme.color.gray600)};
    text-align: right;
    ${Typography('body1').regular};
    .price {
      color: ${({ disabled, theme }) => (disabled ? theme.color.gray400 : theme.color.gray900)};
      margin-left: 0.4rem;
      text-decoration: ${({ disabled }) => (disabled ? 'line-through' : 'none')};
      user-select: none;
      ${Typography('body1').bold};
    }
  }
  .cancel-policy-wrapper {
    margin-top: 0.4rem;
  }
  .almost-exhausted {
    color: ${({ theme }) => theme.color.yaorange};
    ${Typography('body2').bold};
    margin-top: 0.4rem;
  }
  .status-text {
    ${Typography('body2').bold};
    margin-top: 0.4rem;
    color: ${({ theme }) => theme.color.gray900};
  }
`

export const WarningNotice = styled.div`
  display: flex;
  align-items: flex-start;
  color: ${({ theme }) => theme.color.yaorange};
  margin-top: 1.2rem;
  svg {
    flex: 0 0 1.6rem;
    path {
      fill: ${({ theme }) => theme.color.yaorange};
    }
  }
  span {
    word-break: keep-all;
    ${Typography('body2').bold};
    margin: 0.2rem 0 0 0.2rem;
  }
`
